import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { INeighborhoodSpacesConnectionWithTotal } from '@api/types'
import { NeighborhoodSpaces } from '@api/fragments'

interface Payload {
  data: {
    node: INeighborhoodSpacesConnectionWithTotal
  }
}

export const neighborhoodSpacesQuery = gql`
  query NeighborhoodSpaces($id: ID!, $where: SpaceWhereInput, $first: Int, $after: String) {
    node(id: $id) {
      ... on Neighborhood {
        ...NeighborhoodSpaces
      }
    }
  }
  ${NeighborhoodSpaces}
`

export default function spaces({
  id,
  first = 5,
  query = '',
  after = '',
}: {
  id: string
  first?: number
  query?: string
  after?: string
}): Promise<INeighborhoodSpacesConnectionWithTotal> {
  return client.gql
    .query({
      query: neighborhoodSpacesQuery,
      variables: {
        id,
        first,
        where: { externalId_contains: query },
        after,
      },
    })
    .then(({ data: { node } }: Payload) => node)
}
